import React from 'react';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';

/**
 * This component renders a row of navigation buttons, including a "Back" button, a "Cancel" button, and a "Next" or "Submit" button. The buttons are displayed in a justified row layout
 * @param {function} [props.onBack] - A callback function to be called when the "Back" button is clicked
 * @param {function} [props.onNext] - A callback function to be called when the "Next" button is clicked
 * @param {function} [props.onCancel] - A callback function to be called when the "Cancel" button is clicked
 * @param {function} [props.onSubmit] - A callback function to be called when the "Submit" button is clicked
 * @param {boolean} [props.showCancel=false] - A flag indicating whether the "Cancel" button should be displayed
 * @returns {JSX.Element} - The rendered NavigationButtons component
 */
const NavigationButtons = ({ onBack, onNext, onCancel, onSubmit, showCancel = false }) => {
  return (
    <Row alignmentHorizontal="justify">
      <Button onClick={onBack} type="secondary" disabled={!onBack}>
        Back
      </Button>
      <Row>
        {showCancel && (
          <Button onClick={onCancel} type="tertiary">
            Cancel
          </Button>
        )}
        <Button onClick={onSubmit || onNext}>{onSubmit ? 'Submit' : 'Next'}</Button>
      </Row>
    </Row>
  );
};

export default NavigationButtons;
